import type { HabitDestination } from "../navigation";
import { SINGLESITE, FREEFORM, MULTIDAY } from "../navigation";

export function getHabitUrl(destination: HabitDestination, id: string) {
  if (destination === SINGLESITE) {
    return `/site/${id}`;
  }
  if (destination === FREEFORM) {
    return `/daily/${id}`;
  }
  if (destination === MULTIDAY) {
    return `/multiday/${id}`;
  }
  return "/";
}
